import React from "react";
import RapolasLogo from "../logo/rapolasLogo.tsx";
import styles from "./header.module.scss";

export default function Header() {
  return (
    <>
      <div className={styles.headerLayout}>
        <span className={styles.logo}>
          <RapolasLogo />
        </span>
        <span className={styles.headerTitle}>Rapolas Skripkauskas</span>
        <div className={styles.shape}></div>
      </div>
    </>
  );
}
